import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" };
const _hoisted_3 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center mb-25" };
const _hoisted_5 = { class: "card-title fw-bold mb-0" };
const _hoisted_6 = { class: "d-flex gap-2" };
const _hoisted_7 = ["disabled"];
const _hoisted_8 = {
    key: 0,
    class: "fas fa-spinner fa-spin me-2"
};
const _hoisted_9 = { class: "row" };
const _hoisted_10 = { class: "col-lg-8" };
const _hoisted_11 = { class: "form-group mb-20" };
const _hoisted_12 = { class: "form-group mb-20" };
const _hoisted_13 = { class: "input-group" };
const _hoisted_14 = { class: "form-group mb-20" };
const _hoisted_15 = { class: "quill-wrapper" };
const _hoisted_16 = { class: "form-group mb-20" };
const _hoisted_17 = { class: "col-lg-4" };
const _hoisted_18 = { class: "card border p-3 bg-light-subtle mb-4 rounded-1" };
const _hoisted_19 = {
    key: 0,
    class: "image-preview mb-3 text-center border bg-white p-2"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
    key: 1,
    class: "mt-2 text-center"
};
const _hoisted_22 = { class: "card border p-3 bg-light-subtle mb-4 rounded-1" };
const _hoisted_23 = { class: "form-group mb-3" };
const _hoisted_24 = { class: "form-group mb-0" };
const _hoisted_25 = { class: "d-flex flex-column gap-2" };
const _hoisted_26 = { class: "form-check" };
const _hoisted_27 = { class: "form-check" };
const _hoisted_28 = { class: "form-check" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_QuillEditor = _resolveComponent("QuillEditor");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_LoaderComponent)
                ]))
                : (_openBlock(), _createElementBlock("form", {
                    key: 1,
                    onSubmit: _cache[13] || (_cache[13] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.savePost && _ctx.savePost(...args)), ["prevent"]))
                }, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.action === 'add' ? 'Créer un nouvel article' : 'Modifier l\'article'), 1),
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                class: "btn btn-outline-secondary rounded-0 px-4"
                            }, " Annuler "),
                            _createElementVNode("button", {
                                type: "submit",
                                class: "btn btn-primary rounded-0 px-4",
                                disabled: _ctx.isSaving
                            }, [
                                (_ctx.isSaving)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                                    : _createCommentVNode("", true),
                                _cache[14] || (_cache[14] = _createTextVNode(" Enregistrer ", -1))
                            ], 8, _hoisted_7)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label fw-bold" }, "Titre de l'article *", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control shadow-none rounded-0 fs-16",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.post.title) = $event)),
                                    onInput: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_ctx.updateSlug && _ctx.updateSlug(...args))),
                                    placeholder: "Ex: Les secrets de notre pizza artisanale",
                                    required: ""
                                }, null, 544), [
                                    [_vModelText, _ctx.post.title]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label fw-bold" }, " Slug (URL) ", -1)),
                                _createElementVNode("div", _hoisted_13, [
                                    _cache[16] || (_cache[16] = _createElementVNode("span", { class: "input-group-text bg-light border-end-0 rounded-0" }, "/blog/", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "form-control shadow-none border-start-0 rounded-0",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.post.slug) = $event)),
                                        placeholder: "url-de-l-article"
                                    }, null, 512), [
                                        [_vModelText, _ctx.post.slug]
                                    ])
                                ]),
                                _cache[18] || (_cache[18] = _createElementVNode("small", { class: "text-muted" }, "L'URL unique de votre article sur le site web.", -1))
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label fw-bold" }, "Contenu *", -1)),
                                _createElementVNode("div", _hoisted_15, [
                                    _createVNode(_component_QuillEditor, {
                                        theme: "snow",
                                        "content-type": "html",
                                        content: _ctx.post.content,
                                        "onUpdate:content": _cache[4] || (_cache[4] = ($event) => ((_ctx.post.content) = $event)),
                                        placeholder: "Rédigez votre article ici...",
                                        toolbar: "full"
                                    }, null, 8, ["content"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label fw-bold" }, "Extrait / Résumé", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                    class: "form-control shadow-none rounded-0",
                                    rows: "3",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.post.excerpt) = $event)),
                                    placeholder: "Un court texte pour accrocher le lecteur sur la liste du blog..."
                                }, null, 512), [
                                    [_vModelText, _ctx.post.excerpt]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _cache[23] || (_cache[23] = _createElementVNode("h6", { class: "fw-bold border-bottom pb-2 mb-3" }, "Image de couverture", -1)),
                                (_ctx.post.imageUrl)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                        _createElementVNode("img", {
                                            src: _ctx.post.imageUrl,
                                            class: "img-fluid rounded-1",
                                            alt: "Preview"
                                        }, null, 8, _hoisted_20)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                    class: "upload-area p-3 border-dashed text-center bg-white cursor-pointer",
                                    onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.$refs.fileInput.click()))
                                }, [
                                    _cache[21] || (_cache[21] = _createElementVNode("i", { class: "flaticon-gallery-1 fs-2 text-muted mb-2 d-block" }, null, -1)),
                                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "small d-block" }, "Cliquez pour ajouter une image", -1)),
                                    _createElementVNode("input", {
                                        type: "file",
                                        ref: "fileInput",
                                        class: "d-none",
                                        accept: "image/*",
                                        onChange: _cache[6] || (_cache[6] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleImageSelect && _ctx.handleImageSelect(...args)))
                                    }, null, 544)
                                ]),
                                (_ctx.post.imageUrl)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.post.imageUrl = '')),
                                            class: "btn btn-link text-danger btn-sm p-0"
                                        }, "Supprimer l'image")
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                                _cache[30] || (_cache[30] = _createElementVNode("h6", { class: "fw-bold border-bottom pb-2 mb-3" }, "Publication", -1)),
                                _createElementVNode("div", _hoisted_23, [
                                    _cache[25] || (_cache[25] = _createElementVNode("label", { class: "form-label small fw-bold" }, "Statut", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                        class: "form-select shadow-none rounded-0",
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.post.status) = $event))
                                    }, [...(_cache[24] || (_cache[24] = [
                                            _createElementVNode("option", { value: "DRAFT" }, "Brouillon", -1),
                                            _createElementVNode("option", { value: "PUBLISHED" }, "Publié", -1)
                                        ]))], 512), [
                                        [_vModelSelect, _ctx.post.status]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                    _cache[29] || (_cache[29] = _createElementVNode("label", { class: "form-label small fw-bold" }, "Design / Template", -1)),
                                    _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("div", _hoisted_26, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "radio",
                                                name: "template",
                                                id: "t1",
                                                value: 1,
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.post.templateId) = $event))
                                            }, null, 512), [
                                                [_vModelRadio, _ctx.post.templateId]
                                            ]),
                                            _cache[26] || (_cache[26] = _createElementVNode("label", {
                                                class: "form-check-label ms-2",
                                                for: "t1"
                                            }, "Standard (Article large)", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_27, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "radio",
                                                name: "template",
                                                id: "t2",
                                                value: 2,
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.post.templateId) = $event))
                                            }, null, 512), [
                                                [_vModelRadio, _ctx.post.templateId]
                                            ]),
                                            _cache[27] || (_cache[27] = _createElementVNode("label", {
                                                class: "form-check-label ms-2",
                                                for: "t2"
                                            }, "Recette (Ingrédients à part)", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_28, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "radio",
                                                name: "template",
                                                id: "t3",
                                                value: 3,
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.post.templateId) = $event))
                                            }, null, 512), [
                                                [_vModelRadio, _ctx.post.templateId]
                                            ]),
                                            _cache[28] || (_cache[28] = _createElementVNode("label", {
                                                class: "form-check-label ms-2",
                                                for: "t3"
                                            }, "Magazine (Typographie riche)", -1))
                                        ])
                                    ])
                                ])
                            ]),
                            _cache[31] || (_cache[31] = _createElementVNode("div", { class: "alert alert-info border-0 rounded-1 small" }, [
                                _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                                _createTextVNode(" N'oubliez pas d'enregistrer vos modifications. Les articles publiés sont visibles immédiatement sur le site web. ")
                            ], -1))
                        ])
                    ])
                ], 32))
        ])
    ]));
}
